<template>
    <div class="app-windows">
        <!--<a class="btn btn--primary" @click="add()">Adicionar</a>
        <a class="btn btn--primary" @click="remove()">Remover</a>
        <a class="btn btn--primary" @click="getAll()">Pegar todos</a>-->
        <div class="windows__container">
            <app-window v-for="STATE_request in STATE_requests" :key="STATE_request.id" :STATE_request="STATE_request"></app-window>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapActions } from 'vuex'

    import WindowComponent from './Window'

    export default {
        data(){
            return {
            }
        },
        components: {
            'app-window': WindowComponent
        },
        computed: {
            ...mapState("request-board", ["isLoading"]),
            STATE_requests(){
                const STATE_requests = this.VXORM.STATE_Request.query()
                    .with('request.responsibleUser')
                    .with('request.requestContact')
                    .with('request.requestContact.contact')
                    .with('request.requestContact.contact.contactPhones')
                    .with('request.requestContact.contact.contactAddresses')
                    .with('request.requestContact.contact.contactAddresses.address')
                    .with('request.requestContact.contact.contactRequestContacts')
                    .with('request.requestContact.contactPhone')
                    .with('request.requestContact.contactAddress')
                    .with('request.requestOrder')
                    .with('request.requestOrder.requestOrderProducts')
                    .with('request.requestOrder.requestOrderServices')
                    .with('request.requestOrder.requestOrderPayments.paymentMethod')
                    .with('request.STATE_request')
                    .all()
                return STATE_requests.filter(value => value.window.show)
            }
        },
        methods: {
            ...mapActions('toast', ['showError'])
        }
    }
</script>

<style lang="scss" scoped>
    .app-windows {
        position: absolute;
        z-index: 500001;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        .windows__container {
            pointer-events: initial;
            .window {
                width: 420px;
                height: 300px;
                background-color: #990000;
            }
        }
        .btn {
            width: 200px;
            margin-left: 10px;
            margin-top: 10px;
            float: left;
            pointer-events: initial;
        }
    }
</style>
